"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LootBoxMintButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const exchange_1 = require("@framework/exchange");
const mintBox_json_1 = __importDefault(require("@framework/abis/json/ERC721LootBoxSimple/mintBox.json"));
const hooks_1 = require("../../../../../hooks");
const dialogs_1 = require("../../../../../dialogs");
const validation_1 = require("./dialog/validation");
const LootBoxMintButton = (props) => {
    const { className, loot, loot: { template }, disabled, variant, } = props;
    const { address: account = "" } = (0, wagmi_1.useAccount)();
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { hasPermission } = (0, hooks_1.useSetButtonPermission)(types_1.AccessControlRoleType.MINTER_ROLE, template?.contract?.id);
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        const items = (0, exchange_1.convertDatabaseAssetToChainAsset)(values.lootBox.content.components);
        return writeContractAsync({
            address: template.contract.address,
            abi: mintBox_json_1.default,
            functionName: "mintBox",
            args: [values.account, values.lootBox.templateId, items],
        });
    });
    const handleMintTokenConfirmed = async ({ data }) => {
        await metaFn(data);
    };
    const handleMintToken = () => {
        openDialog(dialogs_1.GlobalDialogKeys.CONTRACT_MINT, loot, {
            initialValues: {
                contractId: template.contractId,
                lootId: 0,
                account,
            },
            validationSchema: validation_1.lootBoxMintValidationSchema,
            message: "dialogs.mintToken",
            testId: "MintForm",
            onExternalConfirm: handleMintTokenConfirmed,
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleMintToken, icon: icons_material_1.AddCircleOutline, message: "form.buttons.mintToken", className: className, dataTestId: "LootBoxMintButton", disabled: disabled || !hasPermission, variant: variant }));
};
exports.LootBoxMintButton = LootBoxMintButton;
//# sourceMappingURL=index.js.map